// src/components/common/MobileBlock.js
import React from 'react';
import { Monitor, Smartphone } from 'lucide-react';

/**
 * Shown instead of the app when the portal is opened in a phone browser.
 * Intentionally self-contained - no auth, theme or router context - so it can
 * render before any provider mounts.
 */
const MobileBlock = () => (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-6 py-10">
        <div className="w-full max-w-sm text-center">
            <div className="relative inline-flex items-center justify-center mb-8">
                <Monitor className="w-16 h-16 text-blue-600" strokeWidth={1.5} />
                <span className="absolute -bottom-1 -right-2 bg-gray-50 rounded-full p-1">
                    <Smartphone className="w-7 h-7 text-gray-400" strokeWidth={1.5} />
                </span>
            </div>

            <h1 className="text-xl font-semibold text-gray-900 mb-3">
                Desktop access only
            </h1>

            <p className="text-sm text-gray-600 leading-relaxed mb-8">
                OakHR isn&apos;t available on mobile browsers. Please open the portal
                on a laptop or desktop computer to continue.
            </p>

            <div className="rounded-lg border border-gray-200 bg-white p-4 text-left">
                <p className="text-xs font-medium text-gray-700 mb-1">Need help?</p>
                <p className="text-xs text-gray-500 leading-relaxed">
                    Contact your HR administrator if you require access and don&apos;t
                    have a computer available.
                </p>
            </div>
        </div>
    </div>
);

export default MobileBlock;
